import { FileInput, Input } from "@mantine/core";
import { useMutation } from "@tanstack/react-query";
import Common from "@utilities/common";
import { FC, useState } from "react";
import { AiOutlineUpload } from "react-icons/ai";
import { VscLoading } from "react-icons/vsc";

interface Props {
    data: IArticle["get"];
}

const Static: FC<Props> = ({ data }) => {
    const [link, setLink] = useState("");

    const { mutate, isLoading } = useMutation(
        ["uploadFile"],
        (file: Blob) =>
            Common.api.articles.UploadStatic({
                id: data.id || 0,
                file: new File([file], name + ".png", {
                    type: "image/png",
                }),
            }),
        {
            onSuccess: ({ data }) => {
                setLink(data.result || "");
            },
        },
    );

    const handleUpload = (file: File | null) => {
        mutate(file || new Blob());
    };

    const inputProps = {
        label: "تصویر ثابت",
        value: "",
        errors: "",
        placeholder: "تصویر ثابت",
    };

    return (
        <div className="max-w-[480px] mt-32 mx-auto">
            <FileInput
                onChange={(file) => handleUpload(file)}
                value={new File([], "")}
                accept="image/jpg,image/jpeg,image/webp,image/png"
                classNames={{
                    input: "border-0 p-0",
                }}
                valueComponent={() => (
                    <Input.Wrapper
                        id="static-file"
                        label={inputProps.label}
                        error={inputProps.errors}
                        classNames={{
                            error: "text-sm",
                            label: "mb-2 text-gray-700 font-medium",
                        }}>
                        <Input
                            id="static-file"
                            variant="filled"
                            color="blue"
                            type="text"
                            placeholder={inputProps.placeholder}
                            disabled={isLoading}
                            value={inputProps.value}
                            invalid={!!inputProps.errors}
                            icon={
                                isLoading ? (
                                    <VscLoading className="animate-spin text-2xl" />
                                ) : (
                                    <AiOutlineUpload />
                                )
                            }
                        />
                    </Input.Wrapper>
                )}
            />

            <div className="mt-4">
                <Input
                    id="static-file-link"
                    variant="filled"
                    color="blue"
                    type="text"
                    placeholder="آدرس تصویر"
                    disabled={isLoading}
                    value={link}
                />
            </div>
        </div>
    );
};

export default Static;
